import {
  Component,
  EventEmitter,
  Input,
  Output,
  inject,
  computed,
} from '@angular/core'

import { ButtonComponent, TagComponent, TypographyComponent } from '@hyperkit'

import { SessionService } from '@hunt/services'

import { PivotItemSource } from '../capture-data-dialog.component'

@Component({
  selector: 'pivot-card',
  standalone: true,
  imports: [TypographyComponent, ButtonComponent, TagComponent],
  templateUrl: './pivot-card.component.html',
  styleUrls: ['./pivot-card.component.scss'],
})
export class PivotCardComponent {
  @Input() title = ''
  @Input() description = ''
  @Input() required = []
  @Input() optional = []
  @Input() selected = false
  @Input() source?: PivotItemSource

  readonly session = inject(SessionService)
  readonly loaded = computed(
    () => !this.session.loading() && this.session.activeHunt() !== null,
  )

  @Output() pivotSelection = new EventEmitter<void>()

  onToggleSelection(): void {
    this.pivotSelection.emit()
  }

  get requiredFieldLabels(): string {
    return this.formatFieldLabels(this.required)
  }

  get optionalFieldLabels(): string {
    return this.formatFieldLabels(this.optional)
  }
  formatFieldLabels(fields: string[]): string {
    if (!fields || fields.length === 0) {
      return 'None'
    }
    return fields.map((field) => this.toLabel(field)).join(', ')
  }

  /** Utility: humanize field name */
  toLabel(field: string): string {
    return field
      .replace(/[-_]/g, ' ')
      .replace(/\b\w/g, (char) => char.toUpperCase())
  }
}
